import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center w-full py-4" }
const _hoisted_2 = { class: "relative bg-gray-100 p-1 rounded-xl flex w-full max-w-2xl shadow-inner" }
const _hoisted_3 = ["onClick"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchFormSwitch',
  props: {
    filter: { default: () => ({}) },
    activeValue: { default: false }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const valuesArray = computed(() => {
  return Object.entries(props.filter.values || {}).map(([val, label]) => ({
    val,
    label,
  }));
});

const activeIndex = computed(() => {
  return valuesArray.value.findIndex(({ val }) => {
    if (props.filter.type === 'bool') {
      return Boolean(props.activeValue) === (val === 'true' || val === true);
    }
    return String(props.activeValue) === String(val);
  });
});

const sliderStyle = computed(() => {
  const count = valuesArray.value.length;
  if (count === 0 || activeIndex.value === -1) return { display: 'none' };
  
  const width = 100 / count;
  const left = activeIndex.value * width;
  
  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "absolute top-1 bottom-1 bg-white rounded-lg shadow-sm transition-all duration-300 ease-out transform",
        style: _normalizeStyle(sliderStyle.value)
      }, null, 4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valuesArray.value, ({ val, label }) => {
        return (_openBlock(), _createElementBlock("button", {
          key: val,
          type: "button",
          class: _normalizeClass(["relative flex-1 flex cursor-pointer items-center justify-center gap-2 py-1.5 text-sm font-light transition-colors duration-200 z-10", [
          (__props.filter.type === 'bool' ? Boolean(__props.activeValue) === (val === 'true' || val === true) : String(__props.activeValue) === String(val))
            ? 'bg-brand-main rounded-lg text-white'
            : 'text-gray-500 hover:text-gray-700'
        ]]),
          onClick: ($event: any) => (emit('update', __props.filter.type === 'bool' ? (val === 'true' || val === true) : val))
        }, _toDisplayString(label), 11, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})